import { render, staticRenderFns } from "./ButtonBar.vue?vue&type=template&id=be6bc352&scoped=true"
import script from "./ButtonBar.vue?vue&type=script&lang=js"
export * from "./ButtonBar.vue?vue&type=script&lang=js"
import style0 from "./ButtonBar.vue?vue&type=style&index=0&id=be6bc352&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be6bc352",
  null
  
)

export default component.exports